import React from 'react';
import { useTranslation } from 'react-i18next';
import { ActivityChart, ChartFrame } from '@ole-ui/ole-ui-components';
import { TextVariants, Text } from '@patternfly/react-core';

const colorScale = ['#4CAF50', '#FFC107'];

type StudentActivity = {
  studentActivity: {
    active: number;
    inactive: number;
    total: number;
  };
};

const ActivityChartFrame = (studentActivity: StudentActivity) => {
  const { t } = useTranslation();

  let data = [];
  let legendData = [];
  let chart = <></>;
  const studentPopoverContent = (
    <>
      <p>
        <b>{t('Active:')}</b> {t('users with at least 1 page of progress')}
      </p>
      <p>
        <b>{t('Inactive:')}</b>{' '}
        {t('users with no activity on the learning subscription')}
      </p>
    </>
  );

  if (
    studentActivity?.studentActivity?.active > 0 ||
    studentActivity?.studentActivity?.inactive > 0 ||
    studentActivity?.studentActivity?.total > 0
  ) {
    const { studentActivity: innerStudentActivity } = studentActivity;
    const { active, inactive } = innerStudentActivity;
    data = [
      { x: t('Active'), y: active },
      { x: t('Inactive'), y: inactive },
    ];

    legendData = [
      { name: `${t('Active')}: ${active}` },
      { name: `${t('Inactive')}: ${inactive}` },
    ];

    chart = (
      <div className="chart-fade-in">
        <ActivityChart
          subTitle={t('Students')}
          ariaDesc={t('Student activity chart')}
          data={data}
          colorScale={colorScale}
          legendData={legendData}
        />
      </div>
    );
  } else {
    chart = <Text component={TextVariants.p}>{t('No data available')}</Text>;
  }

  return (
    <ChartFrame
      subTitle={t('Student Activity')}
      popoverHeader={<div>{t('Student Activity')}</div>}
      className=""
      popoverContent={studentPopoverContent}
      tabs={[
        {
          key: 'student_activity',
          title: '',
          chart,
        },
      ]}
    />
  );
};

export default ActivityChartFrame;
